import { gateway } from "../../../../gateway";

export const postQuote = async (payload: any, token: string) => {
    try {
        const response = await gateway.post(`/quotes/`, payload, {
            headers: { Authorization: `${token}` },
        });

        return response.data.data;
    } catch (error) {
        console.error("Error en la creacion", error);
        throw error;
    }
};
